$dependencyManager.addDependencyCallback('swiper', () => {
  class TestimonialsSlider {
    constructor(container) {
      this.$container = jQuery(container);
      this.containerEl = this.$container.get(0);
      this.$slider = this.$container.find('> .mad-slider');
      this.$slidesContainer = this.$slider.find('> .mad-slider__slides-container');
      this.$slidesWrapper = this.$slidesContainer.find('> .mad-slider__slides');
      this.$prev = this.$container.find('> .mad-slider .mad-slider__button-prev');
      this.$next = this.$container.find('> .mad-slider .mad-slider__button-next');
      this.swiper = null;
      this.initSlider();
    }

    initSlider() {
      // If there are fewer than 1 slides, bail
      const slideCount = this.$slidesWrapper.find('.mad-slider__slide').length;
      if (slideCount === 0) {
        this.$container.css('opacity', '1');
        return;
      }

      // Initialize Swiper on the slides container element directly
      this.swiper = new Swiper(this.$slidesContainer.get(0), {
        // Responsive: 1 on mobile, 2 on tablet, 3 on desktop
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
        loop: slideCount > 1,
        watchOverflow: true,
        slideClass: 'mad-slider__slide',
        wrapperClass: 'mad-slider__slides',
        navigation: {
          nextEl: this.$next.get(0),
          prevEl: this.$prev.get(0),
        },
        breakpoints: {
          // when window width is >= 768px
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: 3,
            spaceBetween: 10,
          }
        },
        updateOnWindowResize: true,
      });

      this.$container.css('opacity', '1');
    }
  }

  jQuery('.mad-slider__container--dynamic-testimonials').each(function() {
    new TestimonialsSlider(this);
  });
});
